export default "__VITE_ASSET__DRLwe1t5__"